import React, { Component } from "react";
import {
  Menu,
  MenuItem,
  ProSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SubMenu,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { Link, withRouter } from "react-router-dom";
import Icon from "../../../components/icon";
import { CircularBar } from "../../../components/progressbar";
// import logo from '../../../assets/images/logo.jpg';/../
import logo from "../../../assets/images/site-images/hasan-foods-logo.png";
// import logosm from '../../../assets/images/logo-sm.jpg';
// import logosm from "../../../assets/images/prokraya-sm.png";
import CryptoJS from "crypto-js";
import logosm from "../../../assets/images/site-images/hassad-small-logo.png";
import { env, env_url } from "../../../environments/env";
import HttpServices from "../../../environments/environment_urls";
import { applicationTransmissionFlow } from "../../../functions/common";
import {
  excludeSupplierRoutes,
  getURLFromURL,
  setActiveMenu,
} from "../../../functions/url-modifications";

class Leftsidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userState: 2,
      previewId: "",
      progress: 0,
      supplierStatus: "",
      companyStatus: false,
      companycontactStatus: false,
      companyscopeStatus: false,
      companybankingStatus: false,
      companydocumentStatus: false,
      companypreviewStatus: false,
      collapsed: false,
      isActive: "",
      menuList: [],
      approvalStatus: false,
      openedState: "",
      toggled: false,
    };
  }

  componentDidMount() {
    this.setState({ supplierStatus: localStorage.getItem("supplierStatus") });
    const token = localStorage.getItem("token");
    const userName = localStorage.getItem("userName");
    if (token !== "InValid User") {
      if (
        excludeSupplierRoutes(window.location.pathname?.replace("/", "")) ===
          false &&
        window.location.pathname?.replace("/", "") !== "forbidden" &&
        env.userInfo &&
        env.userInfo.userName
      ) {
        const authForm = new FormData();
        authForm.append(
          "functionUrl",
          getURLFromURL(window.location.pathname?.replace("/", ""))
        );
        HttpServices.postData(env_url.getRoleAuthorize, authForm)
          .then((resp) => {
            if (
              resp.data === false &&
              window.location.pathname !== "/forbidden"
            ) {
              window.location.replace("/forbidden");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      const form = new FormData();
      const bytes = CryptoJS.AES.decrypt(
        userName,
        applicationTransmissionFlow()
      );
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      form.append("userName", userName);
      HttpServices.postData(env_url.loadUser, form)
        .then((resp) => {
          const userDetails = resp.data;
          env.userInfo = { ...userDetails, username: decryptedData };
          if (userDetails.authorities?.length > 0) {
            if (resp.data) {
              this.getAllMenues(userDetails);
              localStorage.setItem("lastLogin", userDetails.lastLoginDate);
            }
            localStorage.setItem("suppUserId", resp.data?.uid);
            localStorage.setItem("suppId", resp.data?.suppId);
            if (
              userDetails.authorities.some(
                (item) =>
                  item.authority === "SUPPLIER_ADMIN" ||
                  item.authority === "SUPPLIER_USER"
              )
            ) {
              this.getSupplierUserAccount();
            }
          } else {
            alert(
              "You are not assigned with any role. Please contact administrator"
            );
            localStorage.clear();
            window.location.href = "/signin";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location?.pathname !== prevProps.location?.pathname) {
      return this.getActiveMenu();
    }
  }

  getAllMenues = (userDetails) => {
    let menuList = [];
    for (var key in userDetails.menus) {
      const subMenuList = userDetails.menus[key]
        .filter((element, index) => {
          if (index >= 0) {
            return element;
          }
        })
        .map((menu) => {
          return {
            id: menu.id,
            name: menu.description,
            url: "/" + menu.functionUrl,
            activeSubUrl: false,
          };
        });
      if (userDetails.menus[key].length > 1) {
        menuList.push({
          id: userDetails.menus[key][0].id,
          iconName: userDetails.menus[key][0].iconName,
          menuName: userDetails.menus[key][0].moduleName,
          url: "/" + userDetails.menus[key][0].functionUrl,
          activeUrl: false,
          subUrls: subMenuList,
        });
      } else {
        menuList.push({
          id: userDetails.menus[key][0].id,
          iconName: userDetails.menus[key][0].iconName,
          menuName: userDetails.menus[key][0].moduleName,
          url: "/" + userDetails.menus[key][0].functionUrl,
          activeUrl: false,
        });
      }
    }
    this.setState({ menuList }, () => this.getActiveMenu());
  };

  getActiveMenu = () => {
    let menuList = this.state.menuList;
    let mainmenu = window.location.pathname;
    let openState = "";
    if (menuList) {
      for (let i = 0; i < menuList.length; i++) {
        const element = menuList[i];
        element.activeUrl = false;
        if (element.subUrls && element.subUrls?.length > 0) {
          const suburl = element.subUrls?.map((item) => {
            item.activeSubUrl = false;
            return item;
          });
          element.subUrls = suburl;
        }
        if (!element.subUrls && element.url === mainmenu) {
          element.activeUrl = true;
        } else if (element.subUrls && element.subUrls?.length > 0) {
          if (element.subUrls?.some((item) => item.url === mainmenu)) {
            element.activeUrl = true;
            openState = element.id;
            const suburl = element.subUrls?.map((item) => {
              if (item.url?.replace("/", "") === mainmenu?.replace("/", "")) {
                item.activeSubUrl = true;
                return item;
              } else {
                item.activeSubUrl = false;
                return item;
              }
            });
            element.subUrls = suburl;
          }
        } else {
          if (
            element.url?.replace("/", "") ===
            setActiveMenu(mainmenu?.replace("/", ""))
          ) {
            element.activeUrl = true;
            openState = element.id;
            if (element.subUrls && element.subUrls?.length > 0) {
              const suburl = element.subUrls?.map((item) => {
                if (
                  item.url?.replace("/", "") ===
                  setActiveMenu(mainmenu?.replace("/", ""))
                ) {
                  item.activeSubUrl = true;
                  return item;
                } else {
                  item.activeSubUrl = false;
                  return item;
                }
              });
              element.subUrls = suburl;
            }
          }
        }
      }
    }
    this.setState({ menuList, openedState: openState });
  };

  getSupplierUserAccount = () => {
    this.setState({ loader: true });
    const url = env_url.getCompanyDetails;
    HttpServices.getData(url).then((response) => {
      if (response.data) {
        let suppUserObj = response.data.supplierObj;
        if (response.data.progress >= 20) {
          this.setState({ companycontactStatus: true });
        }
        if (response.data.progress >= 35) {
          this.setState({ companyscopeStatus: true });
        }
        if (response.data.progress >= 50) {
          this.setState({ companybankingStatus: true });
        }
        if (response.data.progress >= 65) {
          this.setState({ companydocumentStatus: true });
        }
        if (response.data.progress >= 80) {
          this.setState({ companypreviewStatus: true });
        }
        if (suppUserObj.status === "Pending Approval") {
          this.setState({ approvalStatus: true });
        }
        this.setState({
          previewId: suppUserObj.id,
          progress: response.data.progress ? response.data.progress : 0,
          loader: false,
        });
      }
    });
  };

  toggleSidebar = () => {
    document
      .querySelector(".content-block")
      .classList.toggle("collapsedSidebar");
  };

  checkActiveSubmenu = (menuList, menuItem) => {
    if (menuList && menuItem) {
      for (let i = 0; i < menuList.length; i++) {
        const element = menuList[i];
        if (
          element.id === menuItem.id &&
          element.subUrls.some(
            (item) =>
              item.url ===
              "/" +
                window.location.href.substring(
                  window.location.href.lastIndexOf("/") + 1
                )
          )
        ) {
          element.activeUrl = true;
          break;
        } else {
          element.activeUrl = false;
        }
      }
      this.setState({ menuList });
    }
  };

  menuIconClick = () => {
    this.setState({ collapsed: !this.state.collapsed });
    this.toggleSidebar();
    console.log("11111");
  };

  getActiveMenuItem = (menuItem) => {
    sessionStorage.removeItem("AuctionActiveTab");
    sessionStorage.removeItem("pageNumber");
    sessionStorage.removeItem("pageSize");
    this.props.handleToggleSidebar(false);
    let menuList = this.state.menuList;
    let openState = "";
    if (menuList && menuItem) {
      for (let i = 0; i < menuList.length; i++) {
        const element = menuList[i];
        element.activeUrl = false;
        if (element.subUrls && element.subUrls?.length > 0) {
          const suburl = element.subUrls?.map((item) => {
            item.activeSubUrl = false;
            return item;
          });
          element.subUrls = suburl;
        }
        if (!element.subUrls && element.url === menuItem.url) {
          element.activeUrl = true;
        } else if (element.subUrls && element.subUrls?.length > 0) {
          if (element.subUrls?.some((item) => item.url === menuItem.url)) {
            element.activeUrl = true;
            openState = element.id;
            const suburl = element.subUrls?.map((item) => {
              if (
                item.url?.replace("/", "") === menuItem.url?.replace("/", "")
              ) {
                item.activeSubUrl = true;
                return item;
              } else {
                item.activeSubUrl = false;
                return item;
              }
            });
            element.subUrls = suburl;
          }
        } else {
          if (
            element.url?.replace("/", "") ===
            setActiveMenu(menuItem.url?.replace("/", ""))
          ) {
            element.activeUrl = true;
            openState = element.id;
            if (element.subUrls && element.subUrls?.length > 0) {
              const suburl = element.subUrls?.map((item) => {
                if (
                  item.url?.replace("/", "") ===
                  setActiveMenu(menuItem.url?.replace("/", ""))
                ) {
                  item.activeSubUrl = true;
                  return item;
                } else {
                  item.activeSubUrl = false;
                  return item;
                }
              });
              element.subUrls = suburl;
            }
          }
        }
      }
    }
    this.setState({ menuList, openedState: openState });
  };

  getSubActiveMenu = (menuItem, subMenu) => {
    this.props.handleToggleSidebar(false);
    let menuList = this.state.menuList;
    let openState = "";
    if (menuList && menuItem) {
      for (let i = 0; i < menuList.length; i++) {
        const element = menuList[i];
        element.activeUrl = false;
        if (element.subUrls && element.subUrls?.length > 0) {
          const suburl = element.subUrls?.map((item) => {
            item.activeSubUrl = false;
            return item;
          });
          element.subUrls = suburl;
        }
        if (!element.subUrls && element.url === menuItem.url) {
          element.activeUrl = true;
        } else if (element.subUrls && element.subUrls?.length > 0) {
          if (element.subUrls?.some((item) => item.url === menuItem.url)) {
            element.activeUrl = true;
            openState = element.id;
            const suburl = element.subUrls?.map((item) => {
              if (item.url?.replace("/", "") === subMenu?.replace("/", "")) {
                item.activeSubUrl = true;
                return item;
              } else {
                item.activeSubUrl = false;
                return item;
              }
            });
            element.subUrls = suburl;
          }
        } else {
          if (
            element.url?.replace("/", "") ===
            setActiveMenu(menuItem.url?.replace("/", ""))
          ) {
            element.activeUrl = true;
            openState = element.id;
            if (element.subUrls && element.subUrls?.length > 0) {
              const suburl = element.subUrls?.map((item) => {
                if (
                  item.url?.replace("/", "") ===
                  setActiveMenu(subMenu?.replace("/", ""))
                ) {
                  item.activeSubUrl = true;
                  return item;
                } else {
                  item.activeSubUrl = false;
                  return item;
                }
              });
              element.subUrls = suburl;
            }
          }
        }
      }
    }
    this.setState({ menuList, openedState: openState });
  };

  onOpenChange = (menuItem) => {
    let count = 0;
    let menuList = this.state.menuList;
    if (menuItem.id === this.state.openedState) {
      this.setState({ openedState: "" });
    } else {
      for (let i = 0; i < menuList.length; i++) {
        const element = menuList[i];
        if (element.id === menuItem.id) {
          if (count % 2 === 0) {
            this.setState({ openedState: menuItem.id });
          } else {
            this.setState({ openedState: "" });
          }
        }
      }
    }
  };

  render() {
    const state = this.state;
    const props = this.props;
    return (
      <React.Fragment>
        {(props.supplier || state.supplierStatus === "Pending") && (
          <React.Fragment>
            <ProSidebar
              collapsed={state.collapsed}
              breakPoint="md"
              toggled={props.toggled}
              onToggle={props.handleToggleSidebar}
            >
              <SidebarHeader>
                <div className="block-logo">
                  <Link to="/">
                    <img src={state.collapsed ? logosm : logo} alt="logo" />
                  </Link>
                </div>
                <div className="toggle-block" onClick={this.menuIconClick} />
              </SidebarHeader>
              <SidebarContent>
                <Menu iconShape="square">
                  <MenuItem
                    className={
                      "menu-list-name " +
                      (props.completedCompanyDetails ? "complete" : "") +
                      (state.approvalStatus ? " disableMenu" : "")
                    }
                    icon={<Icon iconName="company-details" iconSize={22} />}
                    active={window.location.pathname === "/company-details"}
                  >
                    <Link
                      to="/company-details"
                      className={
                        "menu-list-name " +
                        (props.completedCompanyDetails ? "complete" : "") +
                        (state.approvalStatus ? " disableMenu" : "")
                      }
                      activeClassName="activeMenu"
                    >
                      <span>Company Details</span>
                    </Link>
                  </MenuItem>
                  <MenuItem
                    className={
                      "menu-list-name " +
                      (props.completedContactReference ? "complete" : "") +
                      (state.companycontactStatus ? "" : "disableMenu") +
                      (state.approvalStatus ? " disableMenu" : "")
                    }
                    icon={<Icon iconName="contact-reference" iconSize={22} />}
                    active={window.location.pathname === "/contact-details"}
                  >
                    <Link
                      to="/contact-details"
                      className={
                        "menu-list-name " +
                        (props.completedContactReference ? "complete" : "") +
                        (state.companycontactStatus ? "" : "disableMenu") +
                        (state.approvalStatus ? " disableMenu" : "")
                      }
                      activeClassName="activeMenu"
                    >
                      <span>Contacts</span>
                    </Link>
                  </MenuItem>
                  <MenuItem
                    className={
                      "menu-list-name " +
                      (props.completedScopeofSupply ? "complete" : "") +
                      (state.companyscopeStatus ? "" : "disableMenu") +
                      (state.approvalStatus ? " disableMenu" : "")
                    }
                    icon={<Icon iconName="scope-of-supply" iconSize={22} />}
                    active={window.location.pathname === "/scope-of-supply"}
                  >
                    <Link
                      to="/scope-of-supply"
                      className={
                        "menu-list-name " +
                        (props.completedScopeofSupply ? "complete" : "") +
                        (state.companyscopeStatus ? "" : "disableMenu") +
                        (state.approvalStatus ? " disableMenu" : "")
                      }
                      activeClassName="activeMenu"
                    >
                      <span>Scope of Supply</span>
                    </Link>
                  </MenuItem>
                  <MenuItem
                    className={
                      "menu-list-name " +
                      (props.completedBanking ? "complete" : "") +
                      (state.companybankingStatus ? "" : "disableMenu") +
                      (state.approvalStatus ? " disableMenu" : "")
                    }
                    icon={<Icon iconName="banking" iconSize={22} />}
                    active={window.location.pathname === "/banking"}
                  >
                    <Link
                      to="/banking"
                      className={
                        "menu-list-name " +
                        (props.completedBanking ? "complete" : "") +
                        (state.companybankingStatus ? "" : "disableMenu") +
                        (state.approvalStatus ? " disableMenu" : "")
                      }
                      activeClassName="activeMenu"
                    >
                      <span>Banking</span>
                    </Link>
                  </MenuItem>
                  <MenuItem
                    className={
                      "menu-list-name " +
                      (props.completedCertificates ? "complete" : "") +
                      (state.companydocumentStatus ? "" : "disableMenu") +
                      (state.approvalStatus ? " disableMenu" : "")
                    }
                    icon={<Icon iconName="certificates" iconSize={22} />}
                    active={window.location.pathname === "/certificates"}
                  >
                    <Link
                      to="/certificates"
                      className={
                        "menu-list-name " +
                        (props.completedCertificates ? "complete" : "") +
                        (state.companydocumentStatus ? "" : "disableMenu") +
                        (state.approvalStatus ? " disableMenu" : "")
                      }
                      activeClassName="activeMenu"
                    >
                      <span title="Documents/Certificates">
                        Documents/Certificates
                      </span>
                    </Link>
                  </MenuItem>
                  <MenuItem
                    className={
                      "menu-list-name " +
                      (props.completedCertificates ? "active" : "") +
                      (state.companypreviewStatus ? "" : "disableMenu")
                    }
                    icon={<Icon iconName="administration" iconSize={22} />}
                    active={window.location.pathname === "/supplier-preview/"}
                  >
                    <Link
                      to={{
                        pathname: "/supplier-preview",
                        state: { id: this.state.previewId },
                      }}
                      className={
                        "menu-list-name " +
                        (props.completedCertificates ? "active" : "") +
                        (state.companypreviewStatus ? "" : "disableMenu")
                      }
                      activeClassName="activeMenu"
                    >
                      <span>Review Profile</span>
                    </Link>
                  </MenuItem>
                  <CircularBar
                    className="mt-5"
                    completed={this.state.progress}
                    addition={"%"}
                    total={100}
                    LabelVal={this.state.progress}
                    showlabel
                    label="Profile Completion"
                  />
                </Menu>
              </SidebarContent>
              <SidebarFooter />
            </ProSidebar>
          </React.Fragment>
        )}

        {props.showMenu &&
          !props.supplier &&
          state.supplierStatus !== "Pending" && (
            <ProSidebar
              collapsed={state.collapsed}
              breakPoint="md"
              toggled={props.toggled}
              onToggle={props.handleToggleSidebar}
            >
              <SidebarHeader>
                <div className="block-logo">
                  <Link to="/">
                    <img src={state.collapsed ? logosm : logo} alt="logo" />
                  </Link>
                </div>
                <div className="toggle-block" onClick={this.menuIconClick} />
              </SidebarHeader>
              <SidebarContent>
                {state.menuList.map((menuitem) => (
                  <Menu iconShape="square" key={menuitem.id}>
                    {menuitem.subUrls ? (
                      <SubMenu
                        open={state.openedState === menuitem.id ? true : false}
                        onOpenChange={() => this.onOpenChange(menuitem)}
                        title={menuitem.menuName}
                        className={menuitem.activeUrl ? "active" : ""}
                        icon={
                          <Icon iconName={menuitem.iconName} iconSize={22} />
                        }
                      >
                        {menuitem.subUrls.map((submenu) => (
                          <MenuItem
                            className={submenu.activeSubUrl ? "active" : ""}
                            key={submenu.id}
                          >
                            <Link
                              to={submenu.url}
                              onClick={() =>
                                this.getSubActiveMenu(menuitem, submenu.url)
                              }
                            >
                              {submenu.name}
                            </Link>
                          </MenuItem>
                        ))}
                      </SubMenu>
                    ) : (
                      <MenuItem
                        className={menuitem.activeUrl ? "active" : ""}
                        icon={
                          <Icon iconName={menuitem.iconName} iconSize={22} />
                        }
                      >
                        <Link
                          to={menuitem.url}
                          onClick={() => this.getActiveMenuItem(menuitem)}
                        >
                          {menuitem.menuName}
                        </Link>
                      </MenuItem>
                    )}
                  </Menu>
                ))}
              </SidebarContent>
              <SidebarFooter />
            </ProSidebar>
          )}
      </React.Fragment>
    );
  }
}

export default withRouter(Leftsidebar);
